


import cookie from "../modules/cookie";

function getDomain(url:string) {
  const regex = /^http(s?):\/\/(www\.)?([^\/?#]+)/i
  const match = url.match(regex);console.info(match)
  return match ? match[0] : ''
}


$.ajax({
  url: './api/getcontextid',
  type: 'POST',
  dataType: 'json',
  data: {
    browserid: cookie.get('qgqp_b_id') || ''
  }
})
.done(function(json) {   
  if(json.contextid) {
    // console.info(json.contextid, json.returncode)
    capInit(json.contextid, json.returncode)
  }
})
.fail(function(error) {
  
})



function capInit(contextid: string, returncode: string){
  var Captcha:any = function (this: any, appid: string, accountId: string, containerId: string,returncode: string, contextId: string, succ: { (): void; (): void }, err: { (): void; (): void }) {
    //accountId、passwordId、containerId均为对应的dom元素id
    var capt:any = null;
    //验证码初始化
    this.Init = function () {
        if (contextId != "") {
            capt = new window.EMCaptcha({
                containerId: containerId,
                appid: appid,
                status:returncode,
                captchaContextId: contextId,
                product: "embed"
            }).onSuccess(function () {
                if (succ && typeof succ == "function") {
                    $.ajax({
                      url: './api/valid',
                      type: 'POST',
                      dataType: 'json',
                      data: {
                        contextid: capt.getValidate().contextId,
                        validateresult: capt.getValidate().validate
                      }
                    })
                    .done(function(json) {   
                      console.info(json)
                      if(json.ReturnCode == 0 && json.Data && json.Data.ValidtyCode == '1'){
                        setTimeout(() => {
                          window.parent.postMessage("silidervalid_ok", getDomain(document.referrer));
                        }, 2500);
                      }
                    })
                    .fail(function(error) {
                      
                    })

                    succ();
                }
            }).onError(function () {
                if (err && typeof err == "function") {
                    err();
                }
            });
        }
        else {
            if (err && typeof err == "function") {
                err();
            }
        }
    }
    //开始验证
    this.Verify = function () {
            // var account = "quoteapi";
            return capt.verify(accountId, '');
     }
    //后台二次认证后重置验证码
    this.Reset = function () {
        this.Init();
        this.Refresh();
    }
    this.Refresh = function(){
      return capt.refresh(accountId, '')
    }
    //获取上下文，后台二次认证用
    this.GetContext = function () {
        return capt.getValidate().contextId;
    }
    //获取认证结果，后台二次认证用
    this.GetValidate = function () {
        return capt.getValidate().validate;
    }
    return this;
  };




  // 前端页面已经定义msg_login和divCaptcha 元素，并且通过 GenContext API 得到验证码上下文和返回值
  // 
  // 
  //   
  // 
  var currentCaptcha  = new Captcha("202504083785", "quoteapi", "divCaptcha", returncode, contextid,
  function(){ }, //也可以继续触发提交按钮
  function(){$("#msg_login").html("验证码服务繁忙，请刷新页面后重试");});
  currentCaptcha.Init();
  currentCaptcha.Refresh();
}